<template>
  <div>
    <Input @on-focus="openGroup = true" @on-clear="clear" clearable v-if="isMore" v-model="text" readonly placeholder="请选择"></Input>
    <Input v-else @on-focus="openGroup = true" :value="name" readonly placeholder="请选择"></Input>

    <Drawer :placement="placement" :closable="false" v-model="openGroup" width='450' draggable class="my-drawer">
      <driver-tool @person="rePerson" @persons="rePersons" :isMore="isMore"></driver-tool>
    </Drawer>
  </div>
</template>
<script>
export default {
  props: ["name", "placement", "isMore"],
  data() {
    return {
      openGroup: false,
      text: ''
    };
  },
  methods: {
    rePerson(v) {
      this.openGroup = false;
      this.$emit("update:id", v.id);
      this.$emit("update:name", v.name);
      this.$emit("update:deviceNo", v.deviceNo);
      this.$emit("person", v);
    },
    rePersons(v) {
      var driverIdList = [];
      for (let i = 0; i < v.length; i++) {

        driverIdList.push(v[i].id);

      }
      this.text = '选择' + driverIdList.length + '个司机';

      this.$emit('driverIdList', driverIdList)
    },
    clear() {
     this.rePersons([])
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/selectDriver.vue